import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnnouncementService } from 'src/app/services/announcement.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.css']
})
export class EventDetailsComponent {
  path: any;
data: any;
  id: any;
  title: any;
  description: any;
  image: any;
  videoUrl: any;
  paragraph: any;
   constructor(private service: AnnouncementService,private route: ActivatedRoute, ) {}
  
   ngOnInit(): void {
     this.path=environment.userApiUrl;
     this.route.paramMap.subscribe(params => {
    this.id = params.get('id') || '';
      });
this.service.getLearnPageById(this.id).subscribe((resp: any) => {
  if (resp.success) {
    this.data = resp.data;
    this.paragraph=resp.data?.description;
    console.log('Data:', this.data);

    // Example: Access specific fields
    this.title = this.data.title;
    this.description = this.data.description;
    this.image = this.data.image;
    this.videoUrl = this.data.url;
  }
});}
}
